<template>
	<div class="page-container">
		<head-top head-title="余额明细" goBack="true"></head-top>

		<div class="balance-detail-page">
			<div class="balance-card">
				<div class="balance-label">可用余额（$）</div>
				<div class="balance-value">{{ balance }}</div>
			</div>

			<div class="list-section">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-empty v-if="!loading && finished && records.length === 0" description="暂无记录" />
					<van-list :offset="40" v-else v-model="loading" :finished="finished" :immediate-check="false"
						:finished-text="finished ? '没有更多了~' : ''" @load="onLoad">
						<div class="record-list">
							<div class="record-item bg_a flex_c" v-for="item in records" :key="item.id">
								<div class="record-info">
									<div class="record-title">{{ item.reason }}</div>
									<div class="record-time">{{ item.createTime }}</div>
								</div>
								<div class="record-amount" :class="{ income: item.changeType === 1 }">
									{{ item.changeType === 1 ? '+' : '' }}{{ item.changeAmount }}
								</div>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
			</div>
		</div>
		<div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
			<van-icon name="back-top" />
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'

import {
		getLoginMember,
		getMineData,
		withdrawChangeRecord
	} from '@/apis/api.js'
	export default {
		name: 'BalanceDetail',
		components: {
			headTop
		},
		data() {
			return {
				balance:'0.00',
				records: [],
				showBackToTop: false,
				
				pageNum: 0,
				total: 0,
				pageSize:10,
				loading: false,
				finished: false,
				refreshing: false,
			}
		},
		mounted() {
					if (!getLoginMember()) {
						this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
						return
					}
					this.getMineInfo()
					this.getList()
					window.addEventListener('scroll', this.handleScroll)
				},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			getMineInfo(){
						getMineData().then(res => {
							this.balance = res.withdrawableCommission|| '0.00'
						})
						.catch(e => {
							if (e.handled) return
							this.$toast(e.msg || '加载失败')
						})
					},
			getList() {
						this.pageNum++
						withdrawChangeRecord({
								pageNum: this.pageNum,
								pageSize: this.pageSize
							})
							.then(res => {
								const rows = res.rows || []
								this.total = res.total || 0
								this.records = this.records.concat(rows)
								if (this.records.length >= this.total) {
									this.finished = true
								} else {
									this.finished = false
								}
							})
							.catch(e => {
								this.finished = true
								if (!e.handled) {
									this.$toast('加载失败')
								}
							})
							.finally(() => {
								this.loading = false
								this.refreshing = false
							})
					},
			onLoad() {
				if (this.refreshing || this.finished) return
				this.getList()
			},
			onRefresh() {
				this.pageNum = 0
				this.records = []
				this.finished = false
				this.getList()
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.showBackToTop = scrollTop > 300
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.balance-detail-page {
			padding:14px;
			.balance-card {
				margin-bottom: 14px;
				background: linear-gradient(180deg, #FEEAB8 0%, #F9D976 100%);
				border-radius: 12px;
				padding: 24px 0;
				text-align: center;

				.balance-label {
					font-size: 14px;
					color: rgba(0, 0, 0, 0.6);
					margin-bottom: 10px;
				}

				.balance-value {
					font-size: 28px;
					font-weight: bold;
					color: #333;
				}
			}

			.list-section {
				padding: 14px 0;

				.record-list {
					.record-item {
						padding: 14px;
						border-radius: 8px;
						margin-bottom: 10px;

						.record-info {
							flex: 1;

							.record-title {
								font-size: 14px;
								color: #333;
								font-weight: bold;
								margin-bottom:6px;
							}

							.record-time {
								font-size: 12px;
								color: #999;
							}
						}

						.record-amount {
							font-size: 16px;
							font-weight: bold;
							color: #e33737;

							&.income {
								color: #39b54a;
							}
						}
					}
				}
			}
		}
		
		.back-to-top {
			position: fixed;
			right: 20px;
			bottom: 90px;
			width: 44px;
			height: 44px;
			background: #ffffff;
			border-radius: 50%;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease;
			z-index: 1000;
		
			&.show {
				opacity: 1;
				visibility: visible;
			}
		
			.van-icon {
				font-size: 24px;
				color: #444;
			}
		}
	}
</style>
